import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';

export default function ImagesSlideshow({ blok }) {
  const styles = clsx('blok-images-slideshow');
  const slideShowWidth = 2400;

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div
        className="overflow-hidden slideshow w-full"
        style={{
          '--slideshow-width': `-${slideShowWidth + 12}px`,
          '--slideshow-duration': '40s',
        }}
      >
        <div className="slideshow-track flex flex-row gap-3">
          {[1, 2].map((count) => (
            <div key={`track-loop-${count}`}>
              <div
                className="flex mb-3 gap-3"
                style={{ width: `${slideShowWidth}px` }}
              >
                {blok?.rows[0]?.images.map((image) => (
                  <div key={`dupa gallery-1-loop-${image.image.alt}`}>
                    {image.image && (
                      <div className="object-cover grow max-h-full">
                        <img
                          src={image.image.filename}
                          className="h-full"
                          alt={image.image.alt}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div
                className="flex ml-[-150px] gap-3 mr-[150px]"
                style={{ width: `${slideShowWidth}px` }}
              >
                {blok?.rows[1]?.images.map((image) => (
                  <div key={`dupa gallery-1-loop-${image.image.alt}`}>
                    {image.image && (
                      <div className="object-cover grow max-h-full">
                        <img
                          src={image.image.filename}
                          className="h-full"
                          alt={image.image.alt}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
